/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yearly_PlanInputs */

const en_yearly_plan = /** @type {(inputs: Yearly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annual`)
};

const ar_yearly_plan = /** @type {(inputs: Yearly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنوي`)
};

const de_yearly_plan = /** @type {(inputs: Yearly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährlich`)
};

const es_yearly_plan = /** @type {(inputs: Yearly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

const fr_yearly_plan = /** @type {(inputs: Yearly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuel`)
};

const it_yearly_plan = /** @type {(inputs: Yearly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuale`)
};

const ja_yearly_plan = /** @type {(inputs: Yearly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年間`)
};

const ko_yearly_plan = /** @type {(inputs: Yearly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연간`)
};

const pt_br_yearly_plan = /** @type {(inputs: Yearly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

const ru_yearly_plan = /** @type {(inputs: Yearly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Год`)
};

const th_yearly_plan = /** @type {(inputs: Yearly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายปี`)
};

const tr_yearly_plan = /** @type {(inputs: Yearly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yıllık`)
};

const zh_cn_yearly_plan = /** @type {(inputs: Yearly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年訂閱`)
};

const zh_tw_yearly_plan = /** @type {(inputs: Yearly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年訂閱`)
};

/**
* | output |
* | --- |
* | "Annual" |
*
* @param {Yearly_PlanInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const yearly_plan = /** @type {((inputs?: Yearly_PlanInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yearly_PlanInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yearly_plan(inputs)
	if (locale === "ar") return ar_yearly_plan(inputs)
	if (locale === "de") return de_yearly_plan(inputs)
	if (locale === "es") return es_yearly_plan(inputs)
	if (locale === "fr") return fr_yearly_plan(inputs)
	if (locale === "it") return it_yearly_plan(inputs)
	if (locale === "ja") return ja_yearly_plan(inputs)
	if (locale === "ko") return ko_yearly_plan(inputs)
	if (locale === "pt_br") return pt_br_yearly_plan(inputs)
	if (locale === "ru") return ru_yearly_plan(inputs)
	if (locale === "th") return th_yearly_plan(inputs)
	if (locale === "tr") return tr_yearly_plan(inputs)
	if (locale === "zh_cn") return zh_cn_yearly_plan(inputs)
	return zh_tw_yearly_plan(inputs)
});